export const SET_USER_WATCHERS = 'SET_USER_WATCHERS';
export const SET_USER_WATCHER = 'SET_USER_WATCHER';
export const UNSET_USER_WATCHER = 'UNSET_USER_WATCHER';
export const SET_WATCHERS = 'SET_WATCHERS';
export const SET_WATCHER = 'SET_WATCHER';
export const CREATE_WATCHER = 'CREATE_WATCHER';
export const DELETE_WATCHER = 'DELETE_WATCHER';
export const SET_DECISION_AS_READ = 'SET_DECISION_AS_READ';
export const SET_ALL_DECISIONS_AS_READ = 'SET_ALL_DECISIONS_AS_READ';
